import 'normalize.css'

import Vue from "vue";
import vClickOutside from 'v-click-outside'
import App from './App/index.vue'
import Vuex from 'vuex';
import store from './store'
import router from './router';
import axios from 'axios';
import track from "@/track";

// анализ ошибок
track()

Vue.use(vClickOutside)

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'https://52krd.ru/wp-json/video-api/v1' : 'https://52krd.ru/wp-json/video-api/v1'
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})

Vue.use(Vuex);
Vue.prototype.$axios = axios;

new Vue({
    router,
    store: store,
    render: h => h(App)
}).$mount('#app');